

























import navdraw from "./components/navdraw.vue";
import { Component, Vue, Ref, Watch } from "vue-property-decorator";
@Component({
  name: "Reference"
})
export default class Reference extends Vue {
  overlay: boolean = false;
  selectedPic: any = "";
  buildingSites: any = [
    {
      adresse: "Magdeborner Weg 4 ",
      ort: "04463 Großpösna",
      pics: [
        {
          src: require("../assets/img/b1/IMG-20190904-WA0001.jpg")
        },
        {
          src: require("../assets/img/b1/IMG-20190904-WA0012.jpg")
        },
        {
          src: require("../assets/img/b1/IMG-20190904-WA0013.jpg")
        },
        {
          src: require("../assets/img/b1/IMG-20190904-WA0014.jpg")
        }
      ]
    },
    {
      adresse: "Zöbigker Weg",
      ort: "04416 Markkleeberg",
      pics: [
        {
          src: require("../assets/img/b2/IMG-20190905-WA0005.jpg")
        },
        {
          src: require("../assets/img/b2/IMG-20190905-WA0014.jpg")
        },
        {
          src: require("../assets/img/b2/IMG-20190905-WA0017.jpg")
        },
        {
          src: require("../assets/img/b2/IMG-20190905-WA0018.jpg")
        },
        {
          src: require("../assets/img/b2/IMG-20190905-WA0022.jpg")
        },
        {
          src: require("../assets/img/b2/IMG-20190905-WA0028.jpg")
        }
      ]
    }
  ];
  openDialog(pic: any) {
    this.selectedPic = pic;
    this.overlay = !this.overlay;
    console.log(pic);
  }
}
